export const createProductActions = (set, get) => ({

  addProduct: (productData, wallId) => {
    const id = wallId || get().activeWallId;
    const { placedProduct, occupiedCells } = productData;

    set((state) => {
      const wall = state.walls[id];

      return {
        walls: {
          ...state.walls,
          [id]: {
            ...wall,
            placedProducts: [...wall.placedProducts, placedProduct],
            occupiedCells: new Set(occupiedCells), // Component provides the calculated set
          },
        },
      };
    });
  },

  removeProduct: (productId, occupiedCells, wallId) => {
    const id = wallId || get().activeWallId;

    set((state) => {
      const wall = state.walls[id];

      return {
        walls: {
          ...state.walls,
          [id]: {
            ...wall,
            placedProducts: wall.placedProducts.filter((prod) => prod.id !== productId),
            occupiedCells: new Set(occupiedCells), // Component provides the recalculated set
          },
        },
      };
    });
  },

  getPlacedProducts: (wallId) => {
    const id = wallId || get().activeWallId;
    return get().walls[id]?.placedProducts || [];
  },

  getProductsByType: (type, wallId) => {
    const id = wallId || get().activeWallId;
    const products = get().walls[id]?.placedProducts || [];

    if (type === 'parent') {
      return products.filter((prod) => prod.isParentSku);
    }
    if (type === 'child') {
      return products.filter((prod) => !prod.isParentSku);
    }
    return products;
  },

  addChildToParent: (childProduct, parentProductId, wallId) => {
    const id = wallId || get().activeWallId;

    set((state) => {
      const wall = state.walls[id];
      const parentProduct = wall.placedProducts.find((prod) => prod.id === parentProductId);

      if (!parentProduct) return state;

      const updatedProducts = wall.placedProducts.map((prod) => {
        if (prod.id === parentProductId) {
          return {
            ...prod,
            childProducts: [...(prod.childProducts || []), childProduct],
          };
        }
        return prod;
      });

      return {
        walls: {
          ...state.walls,
          [id]: {
            ...wall,
            placedProducts: updatedProducts,
          },
        },
      };
    });
  },
});
